import { IFavoriteParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export let ViewedObjectType = {
  Metric: 'metric',
  Collection: 'collection'
};

export interface IMarkViewedParams {
  objectId: string;
  objectType: string;
}

export class MarkViewedRequest extends Request<IMarkViewedParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('markViewed', params);
  }
}
